import { MyRoutes } from "~/config/Paths";

import { SlideNavigationType } from "~/ui";

type ReturnType = {
  navigations: SlideNavigationType[];
};

type PropsType = {
  selectedArray: [boolean, boolean];
  businessSectionId?: string;
};

export const useEmployeeSurveysSlideNavigation = ({
  selectedArray,
  businessSectionId = "",
}: PropsType): ReturnType => {
  const navigations = [
    {
      label: "入力",
      href: MyRoutes.Members.inputEmployeeSurveysIndex({
        q: { business_section_id: businessSectionId },
      }),
      selected: selectedArray[0],
    },
    {
      label: "一覧",
      href: MyRoutes.Members.employeeSurveySubmissionsIndex({
        q: { business_section_id: businessSectionId },
      }),
      selected: selectedArray[1],
    },
  ];

  return {
    navigations,
  };
};
